import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-433c0ff2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "uppercase wc-lg luxury" }, "/", -1))
const _hoisted_2 = { class: "uppercase luxury content wc-lg" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " ...", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))

import router from "@/router";

// Define props

export default /*#__PURE__*/_defineComponent({
  props: {
    item: {
        required: true,
    },
    index: {
        required: true,
        type: Number,
    },
    activeElem: {
        required: true,
    },
    lineRotation: {
        required: false,
        type: Boolean,
    },
},
  setup(__props) {

const props = __props

/**
 * @author Tornike Jortmenadze (Jortsoft)
 */



// Defina global variables
const transitionDelay: number = 5;

// Custom function
const changePage = (link: string): void => {
    if (link !== undefined) router.push(link);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["reasons-item", { prev: __props.lineRotation }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["item", {
                active: __props.activeElem,
                pointer: _ctx.$get(__props.item, 'link.url') !== undefined,
            }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (changePage(_ctx.$get(__props.item, 'link.url'))))
    }, [
      _createElementVNode("div", {
        class: "labelMask",
        style: _normalizeStyle(`transition-delay: ${__props.index / transitionDelay}s`)
      }, null, 4),
      _createElementVNode("p", {
        class: "label uppercase fira wc-lg",
        style: _normalizeStyle(`transition-delay: ${__props.index / transitionDelay}s`)
      }, _toDisplayString(_ctx.$get(__props.item, "teaser")), 5),
      _createElementVNode("div", {
        class: "contentMask",
        style: _normalizeStyle(`transition-delay: ${__props.index / transitionDelay}s`)
      }, [
        _createElementVNode("div", {
          class: "inner",
          style: _normalizeStyle(`transition-delay: ${__props.index / transitionDelay}s`)
        }, [
          _hoisted_1,
          _createElementVNode("p", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.$get(__props.item, "title")), 1),
            _hoisted_3
          ])
        ], 4)
      ], 4),
      _hoisted_4
    ], 2)
  ], 2))
}
}

})